var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico_19_chat2_px24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    id: "Path_2154",
    "data-name": "Path 2154",
    d: "M309.214,894.5a1.288,1.288,0,1,0,.377-.908A1.284,1.284,0,0,0,309.214,894.5Zm5.358,0a1.286,1.286,0,1,0,.376-.908A1.282,1.282,0,0,0,314.572,894.5Zm-10.714,0a1.286,1.286,0,1,0,.376-.908A1.282,1.282,0,0,0,303.858,894.5Zm17.711-4.65a12.009,12.009,0,0,0-2.581-3.838A11.964,11.964,0,0,0,310.5,882.5h-.054a12,12,0,0,0-10.661,17.41l-1.286,5.358a1.233,1.233,0,0,0,1.232,1.232l5.36-1.286a12.046,12.046,0,0,0,5.354,1.286h.056a12.012,12.012,0,0,0,11.066-16.65Zm-4.048,11.733a9.916,9.916,0,0,1-7.021,2.882h-.046a10,10,0,0,1-4.636-1.166l-.225-.12-5.057,1.286,1.286-5.057-.12-.225a9.989,9.989,0,0,1,1.717-11.7,9.894,9.894,0,0,1,7.04-2.944h.044a9.968,9.968,0,0,1,7.018,17.047Z",
    transform: "translate(-298.5 -882.5)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/Message.c57257e9c9d44cd9cf24c03d02608198.svg";
export { ForwardRef as ReactComponent };